import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UnopenedNotificationGroupsCountFragment = { __typename?: 'Account', id: string, notificationGroups: { __typename?: 'NotificationGroupConnection', totalCount: number } };

export const UnopenedNotificationGroupsCount = /*#__PURE__*/ gql`
    fragment UnopenedNotificationGroupsCount on Account {
  id
  notificationGroups(page: {first: 100}, filters: {unopenedOnly: true}) {
    totalCount
  }
}
    ` as unknown as DocumentNode<UnopenedNotificationGroupsCountFragment, unknown>;

        

        
export const useUnopenedNotificationGroupsCountFragment = (
  input: string | Omit<UseFragmentOptions<UnopenedNotificationGroupsCountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<UnopenedNotificationGroupsCountFragment>({
    fragment: UnopenedNotificationGroupsCount,
    fragmentName: 'UnopenedNotificationGroupsCount',
    ...options,
  });
};
  
        